var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shop-alternate-address" },
    [
      _c("global-address-administration", {
        attrs: { addresses: _vm.addresses, show: _vm.show },
        on: {
          saveChanges: function ($event) {
            return _vm.saveToStorage($event.detail)
          },
          close: _vm.closeAlternateAddress,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }